import { useMemo } from 'react';

import { cn } from 'helpers/classnames';
import useMartyContext from 'hooks/useMartyContext';
import SponsoredAdsProduct from 'components/search/SponsoredAdsProduct';
import { getLowStockLabelStatus } from 'helpers/cardUtils';
import Carousel from 'components/common/Carousel/Carousel';
import { BOTTOM_PLACEMENT, TOP_PLACEMENT } from 'constants/sponsoredAds';
import useFetchProductRelation from 'hooks/useFetchProductRelation';
import { getProductWithRelatedStyles } from 'helpers/RecoUtils';

import css from 'styles/components/productdetail/sponsoredAdsCarousel.scss';

const RECOS_TITLE = 'Discover More Items';

const SponsoredAdsCarousel = ({
  CardBottomSlot = null,
  isFullMaxWidth,
  containerClassName,
  makeSponsoredAdClick,
  sponsoredAds = {},
  trackSponsoredAdImpressions,
  preferredResultPlacement = TOP_PLACEMENT
}) => {
  const {
    testId,
    marketplace: {
      search: { msaMelodyImageParams, hasSponsoredAds }
    }
  } = useMartyContext();

  const allResults = [...(sponsoredAds?.results?.top || []), ...(sponsoredAds?.results?.bottom || [])];

  const bottomPlacementStyleIds = sponsoredAds?.results?.bottom?.map(product => product.styleId);
  const [productRelations] = useFetchProductRelation(bottomPlacementStyleIds);

  const products = useMemo(() => {
    if (preferredResultPlacement === BOTTOM_PLACEMENT) {
      return (
        sponsoredAds?.results?.bottom?.map(originalProduct => {
          const { styleId } = originalProduct;
          const isSponsored = true;

          let productWithRelatedStyles = {};

          if (productRelations) {
            productWithRelatedStyles = getProductWithRelatedStyles(styleId, productRelations);
          }

          const finalProduct = { ...productWithRelatedStyles, ...originalProduct, isSponsored };

          return finalProduct;
        }) || []
      );
    } else {
      return (
        // this return is a fail safe, we should not be returning products for PDP page in top placement
        sponsoredAds?.results?.top?.map(product => ({
          ...product,
          isSponsored: true
        })) || []
      );
    }
  }, [allResults, preferredResultPlacement]);

  if (!products || !hasSponsoredAds || products.length === 0) {
    return null;
  }

  return (
    <div className={containerClassName}>
      <div
        className={cn({
          [css.fullMaxWidth]: isFullMaxWidth
        })}
        data-test-id={testId('recoCarousel_SPONSORED_ADS')}
      >
        <Carousel
          header={{ title: RECOS_TITLE }}
          slides={products.map((product, i) => {
            const { styleId, colorId } = product;
            product.isLowStock = getLowStockLabelStatus({ ...product });
            return (
              styleId &&
              colorId && (
                <SponsoredAdsProduct
                  key={`${styleId}-${colorId}`}
                  product={{ ...product, index: i }}
                  relatedStyles={product.relatedStyles}
                  numSponsoredAds={products.length}
                  isInCarousel={true}
                  trackSponsoredAdImpressions={trackSponsoredAdImpressions}
                  makeSponsoredAdClick={makeSponsoredAdClick}
                  msaImageParams={msaMelodyImageParams}
                  CardBottomSlot={CardBottomSlot}
                  isFullMaxWidth={isFullMaxWidth}
                  includeSwatchRowSpace={false}
                />
              )
            );
          })}
        />
      </div>
    </div>
  );
};

export default SponsoredAdsCarousel;
